import React, { useState } from 'react';

import { Grid } from "@mui/material";
import { Section1Grid, Section2Grid, Section3Grid, VantagensTitle, Section4Grid, Section5Grid, StyledLink } from "./Home.js";

import { Footer } from '../../components/Footer/Footer.jsx';
import { Header } from '../../components/Header/Header.jsx';
import { Vantagens } from '../../components/Vantagens/Vantagens.jsx';

import Section1Aviao from '../../assets/cangoo-banner-aviao.png'
import Section1Ball from '../../assets/cangoo-banner-icon-01.png'
import Section1Icon1 from '../../assets/cangoo-banner-icon-aviao.png'
import Section1Icon2 from '../../assets/cangoo-banner-icon-caixa.png'
import Section1Icon3 from '../../assets/cangoo-banner-icon-caminhao.png'
import Section1Canguru from '../../assets/cangoo-banner-mascote.png'


import Section3Img from '../../assets/cangoo-home-img-inicial.png'
import Section5Map from '../../assets/cangoo-home-perceiros-mapa.png'

import Icon1off from '../../assets/cangoo-home-item-aviao-off.png'
import Icon1on from '../../assets/cangoo-home-item-aviao-on.png'

import Icon2off from '../../assets/cangoo-home-item-caminhao-off.png'
import Icon2on from '../../assets/cangoo-home-item-caminhao-on.png'

import Icon3off from '../../assets/cangoo-home-item-caixa-off.png'
import Icon3on from '../../assets/cangoo-home-item-caixa-on.png'





export function Home() {
  const [isIcon1Hovered, setIsIcon1Hovered] = useState(false);
  const [isIcon2Hovered, setIsIcon2Hovered] = useState(false);
  const [isIcon3Hovered, setIsIcon3Hovered] = useState(false);


  const handleMouseOverIcon1 = () => {
    setIsIcon1Hovered(true);
  };

const handleMouseOutIcon1 = () => {
  setIsIcon1Hovered(false);
  };
  

  const handleMouseOverIcon2 = () => {
    setIsIcon2Hovered(true);
  };

  const handleMouseOutIcon2 = () => {
    setIsIcon2Hovered(false);
  };

  const handleMouseOverIcon3 = () => {
    setIsIcon3Hovered(true);
  };

  const handleMouseOutIcon3 = () => {
    setIsIcon3Hovered(false);
  };
 

    return (
      <>
      <Header/>
     
 


 <Section1Grid container>
 <Grid className='sideA' item xs={12} sm={12} md={5}>
   <h2>
   Logística aérea do jeito<br/>
   que sua empresa
   </h2>

  <h1>precisa.</h1>

  <p>
  Cuidamos de tudo o que<br/>
  realmente importa:
  </p>

<div className="hide-container">
<p className='yellow um'>sua empresa,</p>
  <p className='yellow dois'>sua carga,</p>
  <p className='yellow tres'>seu cliente.</p>
</div>


<div className="botao">
<StyledLink to="/cotacao"><span className='button'>Fazer cotação</span></StyledLink>

</div>

  <img className='aviao' src={Section1Aviao} alt="" />

  <div className="canguru-container">
  <img className='canguru' src={Section1Canguru} alt="" />
  </div>

 </Grid>

 <Grid className='sideB' item xs={12} sm={12} md={7}>
 <div className="icone1">
 <img className='bola1' src={Section1Ball} alt="" />
 <img className='IconeBola1' src={Section1Icon1} alt="" />
 </div>

  <div className="icone2">
  <img className='bola2' src={Section1Ball} alt="" />
  <img className='IconeBola2' src={Section1Icon2} alt="" />
  </div>

  <img className='bola3' src={Section1Ball} alt="" />
  <img className='bola4' src={Section1Ball} alt="" />

 <div className="icone3">
 <img className='bola5' src={Section1Ball} alt="" />
 <img className='IconeBola5' src={Section1Icon3} alt="" />
 </div>

  <img className='bola6' src={Section1Ball} alt="" />

  <div className="canguru-container">
  <img className='canguru' src={Section1Canguru} alt="" />
  </div>


 </Grid>

</Section1Grid>


 <Section2Grid container>
 <Grid className='sideA' item xs={12} sm={12} md={4}>
  <div className="card" onMouseOver={handleMouseOverIcon1} onMouseOut={handleMouseOutIcon1}>
    <img src={isIcon1Hovered ? Icon1on : Icon1off} alt="" />
<p>
Transporte aéreo
de cargas com as
principais cias
aéreas.
</p>
  </div>
</Grid>

<Grid className='sideB' item xs={12} sm={6} md={4}>
<div className="card" onMouseOver={handleMouseOverIcon2} onMouseOut={handleMouseOutIcon2}>
<img src={isIcon2Hovered ? Icon2on : Icon2off} alt="" />
<p>
Mais de 60 bases
operacionais
espalhadas em
todo o país.
</p>
</div>
</Grid>

<Grid className='sideC' item xs={12} sm={6} md={4}>
<div className="card" onMouseOver={handleMouseOverIcon3} onMouseOut={handleMouseOutIcon3}>
<img src={isIcon3Hovered ? Icon3on : Icon3off} alt="" />
<p>
Cuidamos de
todo o processo
do início ao fim.
</p>
</div>
</Grid>
</Section2Grid>


<Section3Grid container>
<Grid className='sideA' item xs={12} sm={12} md={6}>
<img src={Section3Img} alt="" />

</Grid>

<Grid className='sideB' item xs={12} sm={12} md={6}>
<h1>Olá!</h1>
<h2>A Cangoo chegou.</h2>

<p>A Cangoo Express surgiu com o intuito de zelar e voltar o
olhar a todos que compõe os processos. Afinal, acreditamos
que todos os envolvidos são de extrema importância para
garantir o processo de uma operação. Do aceite da
mercadoria ao controle da embalagem, do rastreio ao
transporte, <span>da sua empresa até o seu cliente.</span>
<br/><br/>
Realizamos o transporte de mercadorias, com foco maior
no ramo aéreo, porém, oferecemos envios rodoviários
também, para que possamos ser o que mais amamos:
<span className='yellow'> a solução dos problemas logísticos das empresas.</span> 
</p>

<StyledLink to="/sobre"><span className='button'>Conheça a Cangoo</span></StyledLink>
</Grid>
</Section3Grid>


<VantagensTitle>
  <h1>Vantagens de transportar com a Cangoo</h1>
</VantagensTitle>
<Vantagens/>


 <Section4Grid container>
<Grid item xs={12} sm={12} md={12}>
<h1>Por que transportar<br/>
com a Cangoo?</h1>

<p>
Nosso maior diferencial sempre será prestar o melhor atendimento possível, dar suporte, resolver
todas as pequenas burocracias e eventuais problemas que possam vir a surgir, lembrando que
contamos com uma equipe com vasto conhecimento na aérea, com preparo e muita vontade para
fazer nosso trabalho da melhor forma possível.<br/><br/>
Nós realmente nos preocupamos com você, com sua carga e com o seu cliente.<br/><br/>
Atuamos em todo território nacional, tanto para enviar sua mercadoria, quanto para trazê-la até
você, quando falamos isso, é porque dispomos de mais de 60 bases operacionais para atender toda
a demanda.<br/><br/>
Entendemos que somos uma ferramenta de crescimento para nossos clientes. Ao passo que nossos
clientes vendem mercadorias, e que as transportamos, estamos fomentando o relacionamento
entre os mesmos e fazendo o que fazemos de melhor: cuidando de tudo para nossos clientes.
</p>
</Grid>
</Section4Grid>

 <Section5Grid container>
 <Grid className='sideA' item xs={12} sm={12} md={6}>
  <h1>
  Somos<br/>
<span>+60</span><br/>
parceiros espalhados<br/>
por todo o Brasil.
  </h1>

  <p>
  Nosso maior diferencial sempre será prestar o melhor
atendimento possível, dar suporte, resolver todas as
pequenas burocracias e eventuais problemas que
possam vir a surgir.<br/><br/>
Nós realmente nos preocupamos com você, com sua
carga e com o seu cliente!
  </p>
  </Grid>

 <Grid className='sideB' item xs={12} sm={12} md={6}>
<img src={Section5Map} alt="" />
 </Grid>
 </Section5Grid>

      <Footer/>

      </>
    )
  }